import { toast } from "sonner";

type ToastType = "success" | "error" | "info" | "warning";

interface ShowToastOptions {
  message: string;
  description?: string;
  type?: ToastType;
}

export const showToast = ({
  message,
  description,
  type = "success",
}: ShowToastOptions) => {
  const toastFn =
    {
      success: toast.success,
      error: toast.error,
      info: toast.info,
      warning: toast.warning,
    }[type] || toast;

  toastFn(message, {
    description,
    position: "top-center",
    style: {
      width: "max-content",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "10px 16px",
    },
    classNames: {
      title: "font-semibold",
    },
  });
};
